import { LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('mw-word-list')
export class WordListElement extends LitElement {
  @property()
  limit?: number = 0;

  @property()
  words: string[] = [];

  updated() {
    const root = this.renderRoot as HTMLElement;
    root.innerHTML = '';

    const limit = this.limit || Number('Infinity');
    const limitedWords = this.words.slice(0, limit);
    const limited = this.words.length > limit;

    if (limited) {
      limitedWords.push('\u2026'); // add ellipsis to indicate missing words
    }

    // Create an OL with all of words.
    const listEl = document.createElement('ol');
    for (const word of limitedWords) {
      const wordEl = document.createElement('li');
      wordEl.textContent = word;
      listEl.appendChild(wordEl);
    }
    root.append(listEl);

    // Set styles that let us easily determine the maximum word width.
    listEl.style.float = 'left';
    listEl.style.margin = '0';
    listEl.style.padding = '0';
    listEl.style.listStyle = 'none';
    const maxWordWidth = getComputedStyle(listEl).width;

    // Use the maximum word width to set a CSS column width, which yields
    // a dense and easily scan-able columnar display of the words.
    listEl.style.removeProperty('float');

    listEl.style.columnWidth = maxWordWidth;
    listEl.style.columnGap = '1rem';
  }
}
